import {
  Component,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  input,
  model,
} from '@angular/core';
import { notificationAnimations } from './notification-animations';

type NotificationType =
  | 'is-primary'
  | 'is-link'
  | 'is-info'
  | 'is-success'
  | 'is-warning'
  | 'is-danger';

@Component({
  selector: 'ag-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  animations: [...notificationAnimations],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class NotificationComponent {
  readonly isColumn = input<boolean>(undefined);

  readonly type = input<NotificationType>(undefined);

  readonly isMessage = input(false);

  readonly visible = model(true);

  @Output()
  dismissed = new EventEmitter();

  constructor() {}

  dismiss() {
    this.visible.set(false);
    this.dismissed.emit();
  }
}
